module.exports = __webpack_public_path__ + "static/media/de_nuke.8e035cd0.jpg";